// extracted by mini-css-extract-plugin
export var box = "_16-1";
export var checked = "_16-2";
export var descriptionSpacer = "_16-9";
export var disabled = "_16-3";
export var icon = "_16-6";
export var input = "_16-0";
export var labelSpacer = "_16-8";
export var medium = "_16-5";
export var small = "_16-4";
export var text = "_16-7";